import { render, staticRenderFns } from "./BasicCanvas.vue?vue&type=template&id=97a8d21c&scoped=true"
import script from "./BasicCanvas.vue?vue&type=script&lang=js"
export * from "./BasicCanvas.vue?vue&type=script&lang=js"
import style0 from "./BasicCanvas.vue?vue&type=style&index=0&id=97a8d21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a8d21c",
  null
  
)

export default component.exports